import React, { Component } from 'react';
import {connect} from 'react-redux';
import Dropzone from 'react-dropzone';

import * as ActionTypes from '../actions';
import Alert from '../components/Alert';
import Button from '../components/Button';
import Card from '../components/Card';
import CardTitle from '../components/CardTitle';
import Fieldset from '../components/Fieldset';
import Form from '../components/Form';
import FormGroup from '../components/FormGroup';
import Input from '../components/Input';
import Legend from '../components/Legend';

const mapStateToProps = (state) => {
    return {
        items: state.items
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        addParticipantToItem: (participant, identifier) => dispatch(ActionTypes.addParticipantToItem(participant, identifier)),
        updateParticipantForItem: (participant, itemIdentifier, identifier) => dispatch(ActionTypes.updateParticipantForItem(participant, itemIdentifier, identifier)),
        uploadFileToParticipant: (file, fileName, fieldName, itemIdentifier, participantIdentifier) => dispatch(ActionTypes.uploadFileToParticipant(file, fileName, fieldName, itemIdentifier, participantIdentifier))
    };
};


/*
* Since the OVM API can not differentiate between ordinary text fields and date fields we need to do this manually by the fields name
* This constant also exists in Medienreaktor.OVM/Classes/Controller/CartController
*/
const DATE_FIELD_NAMES = [
    "PERSON:GEBURTSDATUM",
];

class ParticipantForm extends Component {

    constructor(props) {
        super(props);
        this.inputRefs = [];

        this.state = {
            isValidated: false,
            isSubmitted: false
        };
    }

    validate = () => {
        let isValidated = true;

        for (const [key, value] of Object.entries(this.inputRefs)) {
            if (value.required) {
                if (value.value) {
                    value.classList.remove('is-invalid');
                }
                else {
                    isValidated = false;
                    value.classList.add('is-invalid');
                }
            }
        }

        this.setState({
            isValidated: isValidated,
            isSubmitted: true
        });

        return isValidated;
    }

    componentDidMount() {
        const {participant} = this.props;

        if (participant) {
            for (const [key, value] of Object.entries(this.inputRefs)) {
                if (participant[key]) {
                    value.value = participant[key];
                }
            }
        }
    }

    handleAddParticipant = event => {
        event.preventDefault();

        const identifier = this.identifierInput.value;
        const isValidated = this.validate();

        if (identifier && isValidated) {
            const participant = new Object();

            for (const [key, value] of Object.entries(this.inputRefs)) {
                participant[key] = value.value;
            }

            this.props.addParticipantToItem(participant, identifier);
            this.props.onSubmit();
        }
    }

    handleUpdateParticipant = event => {
        event.preventDefault();

        const {item, participant, participantIdentifier} = this.props;

        const itemIdentifier = this.identifierInput.value;
        const isValidated = this.validate();

        if (itemIdentifier && isValidated) {
            const participant = new Object();

            for (const [key, value] of Object.entries(this.inputRefs)) {
                participant[key] = value.value;
            }

            this.props.updateParticipantForItem(participant, itemIdentifier, participantIdentifier);
            this.props.onSubmit();
        }
    }

    handleDismiss = event => {
        this.props.onDismiss();
    }

    handleUploadFile = name => acceptedFiles => {
        const {item, participantIdentifier} = this.props;
        const itemIdentifier = item.identifier;

        let file;
        let fileName;

        const fieldName = name;

        const reader = new FileReader();

        acceptedFiles.forEach(acceptedFile => {
            reader.readAsDataURL(acceptedFile);
            reader.onload = () => {
                file = reader.result;
                fileName = acceptedFile.name;

                this.props.uploadFileToParticipant(file, fileName, fieldName, itemIdentifier, participantIdentifier);
            }
        });
    }

    renderField(field) {
        const type = field.DATENTYP;
        const name = field.NAME;
        const label = field.INFO;
        const active = field.INAKTIV == "Ja" ? false : true;
        const required = field.PFLICHTFELD == "Ja" ? true : false;
        const readOnly = field.NURLESEN == "Ja" ? true : false;
        const defaultValue = field.VORGABE;
        const size = (field.BREITE && field.BREITE > 0 ? field.BREITE : null);

        if (active) {
            switch (type) {
                case 'FILE':
                case 'MULTIFILE':
                    const {item, items, participantIdentifier} = this.props;
                    const itemIdentifier = item.identifier;

                    let files;
                    if (participantIdentifier) {
                        if (items[itemIdentifier]['participants'][participantIdentifier].hasOwnProperty(name)) {
                            files = items[itemIdentifier]['participants'][participantIdentifier][name];
                        }
                    }

                    return (
                        <FormGroup label={label} required={required}>
                            {participantIdentifier ? (
                                <Dropzone onDrop={this.handleUploadFile(name)} accept={".jpg,.jpeg,.pdf"}>
                                    {({getRootProps, getInputProps}) => (
                                        <section>
                                            <div class="form-control" {...getRootProps()}>
                                                <input {...getInputProps()} />
                                                <p>Dateien hier ablegen …</p>
                                            </div>
                                            {files && Object.entries(files).map(([key, value]) => (
                                                <div className="my-0_25 file">{key}</div>
                                            ))}
                                        </section>
                                    )}
                                </Dropzone>
                            ) : (
                                <div>Bitte Teilnehmer erst speichern, um Dateien hochladen zu können.</div>
                            )}
                        </FormGroup>
                    );
                case 'STRING':
                case 'MEMO':
                case 'DATE':
                    return (
                        <FormGroup label={label} required={required}>
                            {type === "DATE" || DATE_FIELD_NAMES.indexOf(name) !== -1 ?
                                <Input inputRef={node => this.inputRefs[name] = node} size={size} name={name} required={required} type={"date"} pattern="\d{4}-\d{2}-\d{2}" /> :
                                <Input inputRef={node => this.inputRefs[name] = node} size={size} name={name} required={required} type={"text"} />
                            }
                        </FormGroup>
                    );
                case 'EMAIL':
                    return (
                        <FormGroup label={label} required={required}>
                            <Input type="email" inputRef={node => this.inputRefs[name] = node} size={size} name={name} required={required} />
                        </FormGroup>
                    );
                case 'SELECT':
                    return (
                        <FormGroup label={label} required={required}>
                            <select inputRef={node => this.inputRefs[name] = node} name={name} required={required}>
                                {field.WERTE.WERT.map((value) => (
                                    <option selected={defaultValue == value._attributes.ID} value={value._attributes.ID}>{value._attributes.INFO}</option>
                                ))}
                            </select>
                        </FormGroup>
                    );
            }
        } else {
            return (
                <Input inputRef={node => this.inputRefs[name] = node} type="hidden" value={defaultValue} name={name} />
            );
        }

        return;
    }

    render() {
        const {item, participant} = this.props;
        const {items, isValidated, isSubmitted} = this.state;

        return (
            <Card border="primary">
                <h4 class="card-title">Teilnehmer {participant ? 'bearbeiten' : 'hinzufügen'}</h4>
                <Form>
                    {item.form.GRUPPE.map((group) => (
                        <Fieldset>
                            <Legend>{group._attributes.NAME}</Legend>
                            {Array.isArray(group.FELD) && group.FELD.map((field) => (
                                this.renderField(field)
                            ))}
                            {typeof group.FELD === "object" && this.renderField(group.FELD)}
                        </Fieldset>
                    ))}

                    <Input inputRef={node => this.identifierInput = node} type="hidden" value={item.identifier} name="identifier" placeholder="" />

                    {( ! isValidated && isSubmitted) && (
                        <Alert theme="danger">Bitte füllen Sie alle Pflichtfelder aus.</Alert>
                    )}

                    <Button type="submit" size="sm" onClick={participant ? this.handleUpdateParticipant : this.handleAddParticipant}>Teilnehmerdaten speichern</Button>
                    <Button type="button" size="sm" theme="gray" onClick={this.handleDismiss}>Abbrechen</Button>
                </Form>
            </Card>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ParticipantForm);
